import $ from 'jquery';
import './WixOverlayForAndroid.scss';
import WixOverlayForAndroid from './WixOverlayForAndroid.html';

export function WixOverlayForAndroidComponent(container) {
  $(container).append(WixOverlayForAndroid);
}